import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=11d7fd3e&"
import script from "./CollectionView.vue?vue&type=script&lang=ts&"
export * from "./CollectionView.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionView.vue?vue&type=style&index=0&id=11d7fd3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports